import { useEffect, useMemo, useRef, useState } from 'react';

import type { MutableRefObject } from 'react';

export const useSVGElementWidth = (): [
  MutableRefObject<SVGSVGElement | null>,
  number,
] => {
  const ref = useRef<SVGSVGElement | null>(null);

  const [width, setWidth] = useState(0);

  const resizeObserver = useMemo(
    () =>
      new ResizeObserver((entries) => {
        for (const entry of entries) setWidth(entry.contentRect.width);
      }),
    []
  );

  useEffect(() => {
    const current = ref.current;
    if (current !== null) {
      resizeObserver.observe(current);
      setWidth(current.getBBox().width);
    }
    return () => {
      if (typeof current !== 'undefined' && current !== null) {
        resizeObserver.unobserve(current);
      }
    };
  }, [resizeObserver, ref]);

  return [ref, width];
};
